
import VFormGroup from '~/components/ui/VFormGroup'
import VButton from '~/components/ui/VButton'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState('profile', [
            'currentAccount'
        ]),
        ...mapGetters('profile', [
            'role'
        ]),
    },
    methods: {
        editProject() {
            this.$router.push({ name: 'profile-application-id-edit', params: { id: this.project.id } });
        },
        deleteOrder() {
            this.$axios.delete(`/intellectual-property/application/${this.project.id}/delete`).then((res) => {
                this.$notify({
                    type: 'success',
                    title: res.data.message,
                })
                this.$router.push({
                    name: 'profile-my-orders'
                })
            })
        },
    },
    components: {
        VFormGroup,
        VButton
    }
}
